import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form/immutable'
import { object, func, bool } from 'prop-types'
import { Fieldset, Row, Field } from 'react-gridforms'
import moment from 'moment'
import trim from 'validator/lib/trim'

import CustomDatePicker from 'components/CustomDatePicker'
import Input from 'components/Input'
import SearchModal from 'components/SearchModal'

import Presets from './presets'
import ListFees from './list-fees'

class FormPayment extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openSearch: false,
      bcodesFiltered: props.__bulkcodes
    }
  }

  _showSearch = () => {
    this.setState({
      openSearch: true,
    })
  }

  _hideSearch = () => {
    this.setState({
      openSearch: false,
    })
  }

  _onKeyDown = (e) => {
    if (e.keyCode === 121) {
      this._showSearch()
    }
    if (e.keyCode === 13) {
      const value = trim(e.target.value)
      console.log(value, this.props)
      e.preventDefault()
    }
  }

  _resetBcode() {
    const { dispatch } = this.props
    dispatch(actions.change(`notePaymentState.bulk_code_id`, 0))
    dispatch(actions.change(`notePaymentState.bulkcode_name`, ''))
    dispatch(actions.change(`notePaymentState.bulkcode_code`, ''))
  }

  _onBlur = (e) => {
    if (!e.target.value) {
      this._resetBcode()
      return false
    }

    const res = this._searchBcode(e.target.value)
    if (res.size === 0) {
      this._resetBcode()
      return false
    } else {
      this._onSelectBcode(res.get(0))
    }
  }

  _searchBcode(term) {
    const { __bulkcodes } = this.props

    const regex = new RegExp(term, 'i')
    const filtered = __bulkcodes.filter((item) => item.get('code').search(regex) > -1)
  
    return filtered
  }

  _onSearchBcode = (term) => {
    this.setState({
      bcodesFiltered: this._searchBcode(term),
    })
  }

  _onSelectBcode = (bcode) => {
    const { dispatch } = this.props
    console.log(bcode.get('name'))
    dispatch(actions.change(`notePaymentState.bulk_code_id`, bcode.get('id')))
    dispatch(actions.change(`notePaymentState.bulkcode_name`, bcode.get('name')))
    dispatch(actions.change(`notePaymentState.bulkcode_code`, bcode.get('code')))
    this._hideSearch()
  }

  _renderSearch() {
    const { openSearch, bcodesFiltered } = this.state
    if (!openSearch) {
      return null
    }

    return (
      <SearchModal
        placeholder="Search Bulk Code"
        handleClose={this._hideSearch}
        results={bcodesFiltered}
        onSubmit={this._onSearchBcode}
        onSelectItem={this._onSelectBcode}
      />
    )
  }

  render() {
    const {
      item,
      isShow,
      onSearchStudent,
      onAddFee,
      loadUnpaid,
    } = this.props
    let feeLegend = "Fees"

    if (!isShow) {
      feeLegend = (
        <div className="row">
          <div className="col-xs-6">
            Fees <button type="button" disabled={isShow} onClick={onAddFee} className="btn-inline btn-icon">+</button>
          </div>
          <div className="col-xs-6 text-right">
            <Presets />
          </div>
        </div>
      )
    }

    return (
      <div>
        <Fieldset legend="Payment Information" disabled={isShow}>
        <Row>
          <Field span="1">
            <Input
              model=".refno"
              label="Ref #"
              required
            />
          </Field>
          <Field span="2">
            <CustomDatePicker
              model=".paydate"
              label="Paydate"
              minDate={moment()}
              maxDate={moment().add(5, 'days')}
              disabledKeyboardNavigation
              required
            />
          </Field>
          <Field span="2" data-disabled="true">
            <Input
              model=".sy"
              label="School Year"
              disabled
            />
          </Field>
          <Field span="1" data-disabled="true">
            <Input
              model=".sem"
              label="Sem"
              disabled
            />
          </Field>
        </Row>
        <Row>
        <Field span="1">
          <Input
            model=".bulkcode_code"
            onKeyDown={this._onKeyDown}
            onBlur={this._onBlur}
            label="Bcode Code"
          />
          {this._renderSearch()}
        </Field>
        <Field span="2">
          <Input
            model=".bulkcode_name"
            label="Bcode Name"
            disabled
          />  
        </Field>
      </Row>
        <Row>
          <Field span="1">
            <Input
              model=".student_id_input"
              label="Student ID"
              onBlur={onSearchStudent}
              autoFocus
            />
          </Field>
          <Field span="2">
            <Input
              model=".payee"
              label="Payee"
              required
            />
          </Field>
          <Field span="1">
            {!!item.get('student_id') && !isShow && <button type="button" onClick={loadUnpaid} className="btn btn-info" style={{marginTop: '10px'}}>Load unpaid billing</button>}
          </Field>
        </Row>
      </Fieldset>
      <Fieldset legend={feeLegend} disabled={isShow}>
          <ListFees
            isShow={isShow}
            items={item.get('fees')}
          />
        </Fieldset>
      </div>
    )
  }
}

FormPayment.propTypes = {
  item: object,
  isShow: bool,
  onSearchStudent: func,
  onAddFee: func,
  loadUnpaid: func,
}

function mapStateToProps(state) {
  return {
    __bulkcodes: state.bulkcode.get('items'),
  }
}

export default connect(mapStateToProps)(FormPayment)



// WEBPACK FOOTER //
// ./src/containers/NotePayments/form-payment.js